<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('labelManage.queryTitle') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="labelManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="labelManageInfo.conditions.labelName"
                :placeholder="$t('labelManage.labelNamePlaceholder')" clearable />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="labelManageInfo.conditions.domain" :placeholder="$t('labelManage.domainPlaceholder')"
                style="width:100%" clearable>
                <el-option v-for="item in labelManageInfo.domains" :key="item.statusCd" :label="item.name"
                  :value="item.statusCd" />
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryLabelMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button @click="_resetLabelMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('labelManage.labelInfoTitle') }}</div>
        <el-button type="primary" @click="_openAddLabelModal">
          <i class="el-icon-plus"></i> {{ $t('common.add') }}
        </el-button>
      </div>
      <div class="">
        <el-table :data="labelManageInfo.labels" border style="width: 100%">
          <el-table-column prop="labelName" :label="$t('labelManage.labelName')" align="center" />
          <el-table-column prop="labelCd" :label="$t('labelManage.labelCode')" align="center" />
          <el-table-column prop="domain" :label="$t('labelManage.domain')" align="center">
            <template #default="{ row }">
              {{ row.domain === 'PUBLIC' ? $t('labelManage.publicDomain') : $t('labelManage.otherDomain') }}
            </template>
          </el-table-column>
          <el-table-column prop="labelType" :label="$t('labelManage.labelType')" align="center">
            <template #default="{ row }">
              {{ row.labelType === 'C' ? $t('labelManage.customLabel') : $t('labelManage.systemLabel') }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('labelManage.createTime')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="200">
            <template #default="{ row }">
              <el-button type="text" size="small" @click="_openEditLabelModel(row)">
                {{ $t('common.edit') }}
              </el-button>
              <el-button type="text" size="small" @click="_openDeleteLabelModel(row)">
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :current-page="labelManageInfo.conditions.page" :page-sizes="[10, 20, 30, 50]"
          :page-size="labelManageInfo.conditions.row" layout="total, sizes, prev, pager, next, jumper"
          :total="labelManageInfo.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <add-label ref="addLabelRef" @refresh="_queryLabelMethod" />
    <edit-label ref="editLabelRef" @refresh="_queryLabelMethod" />
    <delete-label ref="deleteLabelRef" @refresh="_queryLabelMethod" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { queryLabel } from '@/api/goods/labelApi'
import AddLabel from '@/components/goods/addLabel/addLabel.vue'
import EditLabel from '@/components/goods/editLabel/editLabel.vue'
import DeleteLabel from '@/components/goods/deleteLabel/deleteLabel.vue'

export default {
  name: 'LabelManage',
  components: {
    AddLabel,
    EditLabel,
    DeleteLabel
  },
  data() {
    return {
      labelManageInfo: {
        labels: [],
        total: 0,
        records: 1,
        domains: [],
        conditions: {
          labelName: '',
          domain: '',
          labelCd: 'C',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      let shopId = this.getShopId();
      this.labelManageInfo.conditions.shopId = shopId
      await this._listLabels()
      this._getDomains()
    },
    async _getDomains() {
      try {
        const { data } = await getDict('s_label', 'domain')
        this.labelManageInfo.domains = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listLabels(page = 1, rows = 10) {
      this.labelManageInfo.conditions.page = page
      this.labelManageInfo.conditions.row = rows
      try {
        const res = await queryLabel(this.labelManageInfo.conditions)
        this.labelManageInfo.labels = res.data
        this.labelManageInfo.total = res.total
        this.labelManageInfo.records = res.records
      } catch (error) {
        console.error('获取标签列表失败:', error)
      }
    },
    _queryLabelMethod() {
      this._listLabels()
    },
    _resetLabelMethod() {
      this.labelManageInfo.conditions.labelName = ''
      this.labelManageInfo.conditions.domain = ''
      this._listLabels()
    },
    _openAddLabelModal() {
      this.$refs.addLabelRef.open()
    },
    _openEditLabelModel(row) {
      this.$refs.editLabelRef.open(row)
    },
    _openDeleteLabelModel(row) {
      this.$refs.deleteLabelRef.open(row)
    },
    handleSizeChange(val) {
      this.labelManageInfo.conditions.row = val
      this._listLabels()
    },
    handleCurrentChange(val) {
      this._listLabels(val)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.ibox-title {
  padding: 15px 15px 7px;
  min-height: 48px;
  border-bottom: 1px solid #e7eaec;
}

.ibox-content {
  padding: 15px;
}
</style>